<template>
    <div class="waitParticular">
      <div class="content-top">
        <div class="left">
          <ul>
          <li>问题类型：{{articleList.type_name}}</li>
          <li>提交人：{{articleList.pname}}</li>
          <li>提交时间：{{articleList.pdate}}</li>
          <li v-show="particularType === '2'">提交时间：{{articleList.hdate}}</li>
          <li v-show="articleType ==='0'">状态：待处理</li>
          <li v-show="articleType ==='1'">状态：已处理</li>
        </ul>
        </div>
        <div class="right">
          <i-button type="success" @click="goBack">返回</i-button>
          <i-button type="success" @click="dealType = true" style="margin-left: .2rem"
          v-show="particularType === '1'">处理完毕</i-button>
        </div>
      </div>
      <div class="contentResult" v-show="particularType === '2'">
        <div class="result">处理结果</div>
        <div class="resultContent"  > {{articleList.result}}</div>
      </div>
      <div class="content-middle">
        <div class="des">问题描述</div>
        <div class="desContent"> {{articleList.content}}</div>
      </div>
      <div class="content-footer">
        <div class="pictureHeader">
          图片
        </div>
        <div class="picture">
          <ul>
            <li v-for="(item,index) in articleList.url" :key="item.index"><img :src='item + "?p=0"'  @click="showPicture(index)"></li>
          </ul>
        </div>
      </div>
      <Modal
        v-model="dealType"
        :mask-closable="false"
        >
        <p slot="header" style="text-align: center"><span>处理结果</span></p>
        <Form ref="pushDeal" :model="pushDeal" :rules="rulesDeal" >
          <FormItem prop="content">
            <i-input type="textarea" :rows="8" v-model="pushDeal.content" placeholder="请输入处理结果"></i-input>
          </FormItem>
        </Form>
        <div slot="footer">
          <Button type="default" size="large" @click="dealCancel">取消</Button>
          <Button type="primary" size="large" @click="dealOk('pushDeal')">确定</Button>
        </div>
      </Modal>
      <Modal
        :mask="false"
        width="830px"
        footer-hide
        v-model="pictureShow">
        <Carousel arrow="always" dots="none" v-model="picIndex" v-if="pictureShow === true">
          <CarouselItem v-for="item in articleList.url" :key="item.index">
           <img style="margin-top: 18px" :src='item + "?p=0"'>
          </CarouselItem>
        </Carousel>
      </Modal>
    </div>
</template>

<script>
import {getProblemDetails, getDealProblem} from '../../../api/api'

export default {
  name: 'waitParticular',
  mounted () {
    this.getArticle()
  },
  computed: {
    articleType () {
      let type = sessionStorage.getItem('articleType')
      return type
    },
    particularType () {
      let type = sessionStorage.getItem('waitType')
      return type
    }
  },
  data () {
    return {
      type: 0,
      picIndex: 0,
      waitType: true,
      dealType: false,
      pictureShow: false,
      articleList: {},
      pushDeal: {
        content: ''
      },
      rulesDeal: {
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async getArticle () {
      let data = {
        id: sessionStorage.getItem('articleId')
      }
      const res = await getProblemDetails(data)
      if (res.code === 0 && res.message === 'ok') {
        this.articleList = res.data
      }
    },
    goBack () {
      this.$router.go(-1)
    },
    dealOk (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let data = {
            id: sessionStorage.getItem('articleId'),
            result: this.pushDeal.content
          }
          const res = getDealProblem(data)
          res.then(result => {
            if (result.code === 0) {
              this.$Message.success('处理完毕')
              this.pushDeal.content = ''
              this.$router.push('waitTask')
            } else {
              this.$Message.warning('提交失败')
            }
          })
        }
      })
    },
    showPicture (index) {
      this.picIndex = index
      this.pictureShow = true
    },
    dealCancel () {
      console.log('11')
      this.dealType = false
    }
  }
}
</script>

<style scoped lang="stylus">
.waitParticular
  font-size .14rem
  .content-top
    width 100%
    display flex
    justify-content space-between
    border 1px solid #ccc
    border-radius .1rem
    height .5rem
    background-color: #fff;
    .left
      height .5rem
      ul
        width 100%
        display flex
        justify-content space-between
        li
          line-height .5rem
          display inline
          margin-left .3rem
    .right
        line-height .5rem
        margin-right .2rem
  .contentResult
    border 1px solid #ccc
    margin-top .2rem
    border-radius .1rem
    background-color: #fff;
    .result
      border-bottom 1px solid #ccc
      line-height .5rem
      padding-left .3rem
    .resultContent
      line-height .3rem
      padding .2rem .2rem .2rem .3rem
      border-radius .1rem
  .content-middle
    border 1px solid #ccc
    margin-top .2rem
    border-radius .1rem
    background-color: #fff;
    .des
      border-bottom  1px solid #ccc
      line-height .5rem
      padding-left .3rem
    .desContent
      line-height .3rem
      padding .2rem .2rem .2rem .3rem
      border-radius .1rem
  .content-footer
    border 1px solid #ccc
    margin-top .2rem
    border-radius .1rem
    background-color: #fff;
    .pictureHeader
      border-bottom  1px solid #ccc
      line-height .5rem
      padding-left .3rem
    .picture
      padding .08rem
      display flex
      justify-content left
      border-radius .1rem
      li
        display inline
        margin-right 0.08rem
        img
          border-radius 10%
          width 1.15rem
          height 1.15rem
</style>



// WEBPACK FOOTER //
// src/views/feedback/child/waitParticular.vue